var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.rate)?_c('div',{staticClass:"discount-tag"},[_vm._v(_vm._s(("会员" + _vm.rate + "折")))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }